export const SURVEY_FORM = {
  id: 1341,
  code: 'survey-1341',
}

export const TRANSLATION_FORM = {
  id: 1352,
  code: 'translations-1352',
}
